var map = {
	"./ADVPLAY.png": "5d28",
	"./AESLOT.png": "2f34",
	"./AFB777.png": "79a1",
	"./AMBPOKER.png": "4409",
	"./AMBSLOT.png": "ce36",
	"./BGLIVE.png": "c25a",
	"./CQ9.png": "64f3",
	"./FASTSPIN.png": "42c1",
	"./FCSLOT.png": "b303",
	"./FOXSLOT.png": "321e",
	"./HABANERO.png": "0213",
	"./JILI-GPLAY.png": "5e6a",
	"./JILISLOT.png": "5e75",
	"./JOKER.png": "af7a",
	"./KINGMAKER.png": "9822",
	"./LUCKYPOKER.png": "90bf",
	"./MARIO.png": "80ba",
	"./MGPLUSSLOT.png": "b71a",
	"./NETENT2.png": "5204",
	"./PGSLOT.png": "1bf8",
	"./PGSOFTDIRECT.png": "cf32",
	"./PLAYSTAR.png": "ae77",
	"./PRAGMATICPLAY.png": "1023",
	"./REDTIGER.png": "2fee",
	"./SEXYBCRT.png": "bdd2",
	"./SPADEGAMING.png": "504a",
	"./SPINX.png": "8a8f",
	"./YLFISH.png": "39ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b51";